import React from 'react';
import { useSelector } from 'react-redux';
import { getdateFormat } from '../../../../base/utils';
import { initialStateModel, LoginState } from '../../../../models/model';
import styles from "./chatleftinod.module.scss";

type userDetails = {
  userDetails:any,
  timeStamp:any,
  message?:any
}

export default function ChatLeftInfo({userDetails, timeStamp, message} :userDetails) {
  const {userdetails}: LoginState= useSelector((state : initialStateModel)=> state.loginReducer);
  let hovertimestamp = getdateFormat(timeStamp);
  let isBookmark = message && (Array.isArray(message) &&
    (message[0]?.message?.messageType === "FILE" || message[0]?.message?.messageType === "IMAGE")) ?
    message[0]?.message?.isSave : message?.message?.isSave;
    

  return (
    <>
       {/* <div className={styles.convMemName}><span>{userdetails?.sip_login_id === userDetails?.sip_login_id? "You": userDetails?.caller_id}</span></div> */}
       <div className={`${styles.convTime} `} >
      {message?.message?.isEdit  &&   <div className={styles.edited}>(edited)</div> }
     {(!(isBookmark) || isBookmark['s' + userdetails?.sip_login_id]) === 1? (<div className={styles.addBookData}><span className="icon_ribbonfill">
        </span>
        {/* <label>Added to your saved items</label> */}
        </div>):null}
      <span>{hovertimestamp}</span>
        {/*         {message.isDelivery ? (<span className="readMsg"></span>) : message.isSent ?
          (<span className="unreadMsg"></span>) :
          <span className="sentMsg"></span>
 
 
        } */}
        
      </div>

      
      
    </>
  );
}
